module.exports = __webpack_public_path__ + "img/pprof_web_memory.a9267bb8.png";